import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
  height: 50px;
  margin-bottom: 20px;

  .card-select__group-heading {
    margin-bottom: 10px;
    padding-left: 25px;
    padding-right: 25px;

    font-weight: 700;
    color: inherit;

    &:empty {
      display: none;
    }
  }

  .card-select {
    height: 100%;
    cursor: pointer;
  }

  .card-select__menu {
    width: 100%;
    min-width: 200px;
  }

  .card-select__control {
    height: 100%;
    border-color: #ebebeb;

    cursor: pointer;

    transition: border-color 0.3s;

    &:hover {
      border-color: ${({ theme }) => theme.blue};
    }

    &--menu-is-open {
      border-color: ${({ theme }) => theme.blue};

      .card-select__dropdown-indicator {
        transform: rotate(180deg);
      }
    }
    .card-select__indicators{
      .card-select__indicator-separator{
        display: none;
      }
    }
    &--is-focused {
      box-shadow: none;
    }
    &--is-focused .card-select__single-value {
      display: none;
    }
  }

  .card-select__value-container {
    position: relative;

    height: 100%;
    padding: 0 10px;

    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.black};
    overflow: visible;
  }
`;

export const CardValue = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  svg {
    min-width: 32px;
    height: 21px;
    margin-right: 10px;
  }

  div {
    display: flex;
    flex-direction: column;
    font-size: 16px;

    span {
      font-size: ${({ smallCred }) => smallCred ? '12px' : '16px'};
    }
  }
`;

export const CardItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 15px 25px;

  font-weight: 400;
  font-size: 16px;
  text-align: left;

  cursor: pointer;

  transition: background-color 0.3s;

  &:hover {
    background-color: #f8f8f8;
  }

  svg {
    min-width: 32px;
    height: 21px;
    margin-right: 10px;
  }

  ${({ isFocused }) => isFocused && css`
    background-color: #f8f8f8;
  `}

  ${({ isSelected }) => isSelected && css`
    font-weight: 700;
    background-color: #f8f8f8;
  `}
`;
